import { Component, OnInit,  Directive, HostListener } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, ValidatorFn, AbstractControl, FormBuilder } from "@angular/forms";
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { HttpService } from 'src/app/services/http.service';
import { UtilService } from 'src/app/services/util.service';
import { FirestoreService } from 'src/app/services/firestore.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loginObj: any;
  loading: boolean = false;
  formSubmitted = false;
  hide : boolean = true;
  showLoader:boolean=true;
  loginCheck:boolean=false;
  // useremail: any = "admin@vecv.com";
  // password: any = "BLPPassword@123";

  constructor( private http: HttpService, private router: Router,private formBuilder: FormBuilder,
     private util: UtilService, private cookie: CookieService, private fstore: FirestoreService,
     private authService:AuthService) {

    this.loginForm = this.formBuilder.group({
      useremail: [null, [Validators.required, Validators.email, Validators.maxLength(40)]],
      password: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(25)]],
      remember: [null, []]
    },
    { validator: this.patternValidator('password') }
    );
   }
 

  ngOnInit() {
    this.showLoader=true;
    let checkRemember: any = this.cookie.get("vecvloginremember");
    if (checkRemember) {
      if (JSON.parse(checkRemember) === true) {
         this.loginForm.get("useremail")?.setValue(this.cookie.get("userid"));
         this.loginForm.get("password")?.setValue(this.cookie.get("password"));
         this.loginForm.get("remember")?.setValue(true);
      } else {
        this.cookie.delete("userid");
        this.cookie.delete("password");
        this.loginForm.get("remember")?.setValue(false);
      }
    }
    this.util.showLoader$.subscribe(data =>{
      this.showLoader=data
      if(data==false){
        this.showLoader=false;
        this.loginCheck=true;
        this.loading=false;
      }
    })
  }
  ngAfterViewInit(){
    const queryParams = new URLSearchParams(window.location.search);
    if(queryParams.get('encrypted')){
      this.loginCheck=false;
      let Obj=JSON.parse(this.util.decrypt(queryParams.get('encrypted')));
      let LoginDetail={
        userid:Obj.email,
        password:Obj.password
      }
      sessionStorage.setItem('vecvexternalLogin','true');
      this.authService.login(LoginDetail);
    }else{
      setTimeout(() => {
        this.showLoader=false;
        this.loginCheck=true;
      });
    }
  }

  patternValidator(key: string) {
    return (group: FormGroup) => {
      const input = group.controls[key];
      if (!input.value) return null;
      if (!input.value.match(/\d/)) {
        return input.setErrors({ hasNumber: true });
      }
      else if (!input.value.match(/[A-Z]/)) {
        return input.setErrors({ hasCapitalCase: true });
      }
      else if (!input.value.match(/[a-z]/)) {
        return input.setErrors({ hasLowerCase: true });
      }
      else if (!input.value.match(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)) {
        return input.setErrors({ hasSpecialCharacters: true });
      }

    };
  }

  login(data: any, callback?) {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      this.loading = false;
      this.showLoader = false;
      this.util.setLoaderValue(false);
      this.util.showSnakbarMessage("error", "Please enter a valid email address and password", "end", "top");
      return;
    }
    this.showLoader=true;
    this.formSubmitted = true;
    this.loading=true;
    let json = {
      userid: data.value.useremail,
      password: data.value.password,
      remember: data.value.remember,
      cliend_id:"VECV"
    };
    this.authService.login(json);
  }
  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }
 
  passwordView() {
    this.hide = !this.hide;
  }
  
}
